// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-upload-switcher-wrapper[data-v-5052d942] {\n  display: flex;\n  margin: 1.5em;\n  margin-top: 1em;\n}", ""]);
// Exports
module.exports = exports;
